import { render, staticRenderFns } from "./MailV2Editor.vue?vue&type=template&id=5476dfaa&scoped=true"
import script from "./MailV2Editor.vue?vue&type=script&lang=js"
export * from "./MailV2Editor.vue?vue&type=script&lang=js"
import style0 from "./MailV2Editor.vue?vue&type=style&index=0&id=5476dfaa&prod&lang=css"
import style1 from "./MailV2Editor.vue?vue&type=style&index=1&id=5476dfaa&prod&scoped=true&lang=css"
import style2 from "./MailV2Editor.vue?vue&type=style&index=2&id=5476dfaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476dfaa",
  null
  
)

export default component.exports